<div class="main-container vertical-as">
  <div
    class="bookmarks-container"
    *ngIf="bookmarks"
    (keydown)="onKeyDown($event, 'bookmarks-container')"
  >
    <app-horizontal-carousel
      *ngIf="bookmarks"
      (focusin)="focusIn(bookmarks?.id, 0)"
      [containers]="bookmarks"
      [aspectRatio]="bookmarks?.aspectRatio"
      [showHeader]="true"
      [isHalfVisible]="true"
      [showPlayIcon]="false"
      [customId]="bookmarks?.id"
      [isTitleVisible]="true"
      [index]="0"
      (click)="clearData()"
    >
    </app-horizontal-carousel>
  </div>
  <div
    class="watchlists-container"
    *ngIf="favourites"
    (keydown)="onKeyDown($event, 'watchlists-container')"
  >
    <app-horizontal-carousel
      (focusin)="focusIn(favourites?.id, 1)"
      [containers]="favourites"
      [aspectRatio]="favourites?.aspectRatio"
      [showHeader]="true"
      [isHalfVisible]="true"
      [showPlayIcon]="false"
      [isTitleVisible]="false"
      [customId]="favourites?.id"
      [index]="1"
      (click)="clearData()"
    >
    </app-horizontal-carousel>
  </div>
  <div
    class="rentals-container"
    *ngIf="rentals"
    (keydown)="onKeyDown($event, 'rentals-container')"
  >
    <app-horizontal-carousel
      (focusin)="focusIn(rentals?.id, 2)"
      [containers]="rentals"
      [aspectRatio]="rentals?.aspectRatio"
      [showHeader]="true"
      [isHalfVisible]="true"
      [showPlayIcon]="false"
      [isTitleVisible]="false"
      [customId]="rentals?.id"
      [index]="2"
      (click)="clearData()"
    >
    </app-horizontal-carousel>
  </div>
</div>
